module.exports = __webpack_public_path__ + "img/840.c1a604b3.svg";